import type { ReactNode } from 'react'
import { Outlet } from 'react-router'
import { eagerDatoImagePreload } from '#src/components/image/EagerDatoImage.js'
import { fetchPageMeta, getClients, getHomeData } from '#src/data/data.js'
import { languageService } from '#src/languageService.js'
import { HERO_SIZES, Home } from '#src/pages/home/Home.js'
import { HomeLanguageDetector } from '#src/pages/home/HomeLanguageDetector.js'
import { mergeMeta } from '#src/seo.js'
import type { Route } from './+types/home.route.js'

// Renders the home content for `/` (and `/sv`); the gallery child route renders
// as a popup in the <Outlet/>. Also hosts the first-visit language detector
// (which redirects `/` -> `/sv` when appropriate; a no-op everywhere else).
export async function loader({ request }: Route.LoaderArgs) {
  const lang = languageService.langFromRequest(request)
  const [data, clients, meta] = await Promise.all([
    getHomeData(lang),
    getClients(),
    fetchPageMeta('homePage', lang, '/'),
  ])
  return { data, clients, meta }
}

export function meta({ loaderData, matches }: Route.MetaArgs): Route.MetaDescriptors {
  return [
    ...mergeMeta(matches[0].meta, loaderData?.meta || []),
    // The hero is the LCP element - start its download from the HTML head.
    ...eagerDatoImagePreload(loaderData?.data.heroImage.responsiveImage, HERO_SIZES),
  ]
}

export default function HomePage({ loaderData }: Route.ComponentProps): ReactNode {
  return (
    <Home data={loaderData.data} clients={loaderData.clients}>
      <HomeLanguageDetector />
      <Outlet />
    </Home>
  )
}
